module.exports = __webpack_public_path__ + "img/BMVI_Foerderlogo_englisch_NEU.9f21dc96.png";